//import liraries
import { Dimensions} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, } from "rn-responsive-styles";
import { COLORS } from "../../constant";
const isSmallDevice = Dimensions.get("window").width < 767;

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    mainContainerStyle: {
      height: Dimensions.get("window").height,
      width: "100%",
    },
    container: {
      width: 350,
      height: 420,
      borderRadius: 15,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.13)",
      shadowOffset: {
        width: 0,
        height: 0.4,
      },
      shadowRadius: 9,
      shadowOpacity: 1,
    },
    userIdWidget:{
      alignItems: 'center',
      marginTop: isSmallDevice ? 20 : 5,
      width: '100%',
    },
    styleWidget:{
      position: 'absolute',
      width: '100%',
      height: 40,
      borderRadius: 6.6,
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: '#cccccc',
      alignSelf: 'center',
    },
    eyeIcon:{
      position: 'absolute',
      right: 10,
      top: 10,
    },
    mobileContainer: {
      width: 350,
      height: 350,
      borderRadius: 15,
      backgroundColor: "#f3f3f3",
    },
    rectangle41: {
      width: "100%",
      height: 55,
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      backgroundImage: "linear-gradient(to right, #f2717b 0%, #9d1d27 100%)",
      borderTopRightRadius: 15,
      borderTopLeftRadius: 15,
    },
    loginTextStyle: {
      fontSize: 18.4,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 22.1,
      letterSpacing: 0,
      textAlign: "center",
      color: "#ffffff",
      justifyContent: "center",
    },
    textInputContainerStyle: {
      width: "100%",
      height: 40,
      borderRadius: 6.6,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#cccccc",
      marginTop: 20,
    },
    textInputStyle: {
      width: 170,
      height: 40,
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 10.1,
      letterSpacing: 5,
      textAlign: "center",
      color: "#666666",
      paddingLeft: 10,
    },
    labelStyle: {
      fontFamily: "Inter",
      fontSize: 8,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 10,
      letterSpacing: 0,
      textAlign: "left",
      color: "blue",
      position: "absolute",
      zIndex: 999,
      top: -5,
      left: 10,
      backgroundColor: "white",
      paddingHorizontal: 3,
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 13,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
    },
    textStyleForgot: {
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: 400,
      color: COLORS.blue500
    },
    captchaInputStyle: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 8.4,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
      alignSelf: "center",
      width: "100%",
      height: "100%",
      textAlign: "center",
    },
    resendViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: 10,
      marginTop: 5,
    },
    timerTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    resendTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "center",
      color: "#bd2d37",
    },
    bodyContainerStyle: {
      flexDirection: "row",
      width: "100%",
      height: 'auto',
      flexWrap: "wrap",
    },
    bodyLeftViewStyle: {
      backgroundColor: "#f3f3f3",
      flex: 0.4,
      alignItems: "center",
      justifyContent: "center",
      paddingTop: 60,
    },
    loginTabIcons: {
      marginBottom: 80,
    },
    keyboardContainer: {
      width: "80%",
      display: "flex",
      flexDirection: "column",  
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      backgroundColor: "#ffffff",
  
  
    },
    virtualkeycheckbox: {
      width: 250,
      backgroundColor: "#ffffff",
      height: 35,
     borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      color: "white",
      borderWidth: 1,
      borderColor: "#ffffff",
      marginTop: 20,
      shadowColor: "rgba(0, 0, 0, 0.13)",
      shadowOffset: {
        width: 0,
        height: 0.4,
      },
      shadowRadius: 9,
      shadowOpacity: 1,
      alignItems: "center",
      alignSelf: "center",
      position:"absolute",
      bottom:0,
    },
     bodyRightViewStyle: {
                backgroundColor: "#ffffff",
                flex: isSmallDevice ? 0.4 : 0.6,
                alignItems: "flex-start",
                flexWrap: "wrap",
                paddingVertical: '6%',
                borderRadius: 5,
            },
   
    mobileComponentStyle: {
      position: "absolute",
      zIndex: 99,
      right: 15,
      left: 0,
      display: "none",
    },
    mobileContentWrapper: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 20,
      marginBottom: 10,
      marginRight: 20,

    },
    mobileContentWidget: {
      alignSelf: "center",
      justifyContent: "center",
      alignContent: "center",
    },
    signInText: {
      fontFamily: "Inter",
      fontSize: 14,
    },
    loginBtmText: {
      fontFamily: "Inter",
      fontSize: isSmallDevice ? 12 : 15,
      lineHeight: 17,
      textAlign: "left",
      color: "#54565b",
      alignSelf: "center",
      paddingTop: 10,
    },
    loginHereText: {
      fontFamily: "Inter",
      fontSize: isSmallDevice ? 12 : 15,
      lineHeight: 17,
      letterSpacing: 0,
      textAlign: "left",
      color: "#9c1d25",
    },
    captchaWidget: {
      width: "50%",
      flexDirection: "row",
      backgroundColor: "#f3f3f3",
      alignItems: "center",
      justifyContent: "center",
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10,
      justifyContent: "center",
    },
    captchaIconWrapper: {
      width: "20%",
      height: 40,
      justifyContent: "center",
      alignItems: "flex-end"
    },
    captchaText: {
      fontStyle: "italic",
      fontSize: 18,
      fontFamily: "auto",
      letterSpacing: 8,
      textAlign: "center",
      paddingLeft: 4,
    },
    captchaTextWidget: {
      alignItems: "center",
      width: "50%",
      borderRightWidth: 1,
      borderRightColor: "#cccccc",
      justifyContent: "center",
      flexDirection: "row"
    },
    signInWidget: {
      width: "80%",
      height: 36,
      marginTop: 20
    },
    captchaBg: {
      flexDirection: "row",
      width: "80%",
      height: 40,
      borderRadius: 10,
      borderWidth: 1,
      marginTop: 20,
      borderColor: "#cccccc",
    },
    forgotTextWidget: {
      flexDirection: "row",
      marginTop: 30,
      width: "78%",
      justifyContent: "space-between",
      marginRight: 20,
      marginLeft: 20,
      position: "relative",
      zIndex: 99,
      alignItems:'center'
    },
    captchaTextWeb: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "normal",
      lineHeight: 8.4,
      textAlign: "center",
      color: "#999999",
      // "align-self": "center",
      width: "100%",
      height: "90%",
      borderWidth: 0,
      borderRadius: 10
    },
    tabsWrapper: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 20,
      marginTop:14,
      paddingBottom:10
    },
    tabsLine: {
      width: 1,
      height: 20,
      backgroundColor: COLORS.gray300
    },
    btmBtnWidget: {
      width: '100%',
      height: 37,
      alignSelf: "center",
      marginTop: 20,
    },
    resendBg: {
      backgroundColor: COLORS.grayOP69,
      width: 100,
      borderRadius: 10,
      marginLeft: 10,
      height: 40,
      textAlign: 'center'
    },
    otpInputBoxWidget: {
      marginTop: 20,
      flexDirection: 'row'
    },
    inputWrapper: {
      minHeight: 120
    },
    mblPrefixText: {
      position: 'absolute',
      width: 30,
      top: 0,
      zIndex: 99,
      height: 40,
      justifyContent: "center",
      left: 10
    },
    mblTextInput: {
      width: "100%",
      height: 40,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: -0.26,
      textAlign: "left",
      color: "#6e6e6e",
      paddingLeft: 40,
    },
    footerWidget: {
      width: '100%',
      height: '10%',
      alignSelf: "center",
    },

  },

  {
    [DEVICE_SIZES.LG]: {
      mainContainerStyle: {
        height: Dimensions.get("window").height,
        width: "100%",
      },
      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3.2,
        flexWrap: "wrap",
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.4,
        alignItems: "center",
        justifyContent: "center",
      },
      mobileComponentStyle: {
        display: "none",
      },

    },
    [DEVICE_SIZES.MD]: {
      mainContainerStyle: {
        height: Dimensions.get("window").height,
        width: "100%",
      },
      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3,
        flexWrap: "wrap",
        marginTop: -20,
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.5,
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      },
      mobileComponentStyle: {
        display: "none",
      },
    },
    [DEVICE_SIZES.SM]: {
      mainContainerStyle: {
        height: Dimensions.get("window").height,
        width: "100%",
      },
      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3,
        flexWrap: "wrap",
        marginTop: -20,
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.5,
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      },
      mobileComponentStyle: {
        display: "none",
      },
      virtualkeycheckbox: {
        width: 250,
        backgroundColor: "#ffffff",
        height: 35,
       borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        color: "white",
        borderWidth: 1,
        borderColor: "#ffffff",
        marginTop: 30,
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        alignItems: "center",
        alignSelf: "center",
        position:"absolute",
        bottom:0,
      },
    },

    [DEVICE_SIZES.XS]: {
      container: {
        width: 330,
        height: 400,
        borderRadius: 15,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        // alignItems:"center"
      },
      mobileContainer: {
        width: 320,
        height: 350,
        borderRadius: 15,
        backgroundColor: "#f3f3f3",
      },
      rectangle41: {
        width: "100%",
        height: 39,
        borderTopRightRadius: 15,
        borderTopLeftRadius: 15,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
      },
      loginTextStyle: {
        fontSize: 18.4,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 22.1,
        letterSpacing: 0,
        textAlign: "center",
        color: "#ffffff",
        justifyContent: "center",
      },
      textInputContainerStyle: {
        width: "100%",
        height: 40,
        borderRadius: 6.6,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#cccccc",
        marginTop: 20,
      },
      textInputStyle: {
        width: 170,
        height: 40,
        fontFamily: "Arboria",
        fontSize: 10,
        fontWeight: "bold",
        fontStyle: "normal",
        lineHeight: 10.1,
        letterSpacing: -0.17,
        textAlign: "left",
        color: "#666666",
        paddingLeft: 10,
      },
      labelStyle: {
        fontFamily: "Inter",
        fontSize: 8,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 10,
        letterSpacing: 0,
        textAlign: "left",
        color: "blue",
        position: "absolute",
        zIndex: 999,
        top: -5,
        left: 10,
        backgroundColor: "white",
        paddingHorizontal: 3,
      },
      textStyle: {
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 13,
        letterSpacing: 0,
        textAlign: "left",
        color: "#999999",
      },
      captchaInputStyle: {
        fontFamily: "Inter",
        fontSize: 11,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 8.4,
        letterSpacing: 0,
        textAlign: "left",
        color: "#999999",
        alignSelf: "center",
        width: "70%",
        height: "100%",
        textAlign: "center",
      },
      mainContainerStyle: {
        height: 1100,
        minHeight: 850,
        maxHeight: 1100,
        width: "100%",
      },
      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3,
        flexWrap: "wrap",
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.45,
      },
      mobileComponentStyle: {
        display: "flex",
        backgroundColor: '#f3f3f3',
        width: '100%',
      },
      virtualkeycheckbox: {
        width: 250,
        backgroundColor: "#ffffff",
        height: 35,
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        color: "white",
        borderWidth: 1,
        borderColor: "#ffffff",

        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        alignItems: "center",
        alignSelf: "center",
        position: "relative",

      },
    },
  }
);




export default useStyles;
